import OwnersTransactionsTable from "./table";

const OwnersTransactions = () => {
  return <OwnersTransactionsTable />;
};

export default OwnersTransactions;
